// import { Stat } from "./stat.model";
import { Extension } from './csTypes/extension';
import { Shot } from './shot.model';
import { User } from './user.model';
import { CourtSide } from './enums/court-side';
import { IPlayerCourtTimeLog } from './match.model';

export class Point {
    // Point duration is in milliseconds
    pointDuration?: number;
    pointNumber?: number;
    shots?: Shot[];
    serverSide?: number;
    server?: Server;
    returner?: Server;
    side1Score?: number = 0;
    side2Score?: number = 0;
    timestamp?: Date;
    winningSide?: number;
    winReason?: string;
    rallyLength?: string;
    extensions?: Extension[] = [];
    playerPositions?:PlayerPosition;
    startPointTimeStamp?: Date;
    timeout?: Timeout[] = [];
    substitutions?: IPlayerCourtTimeLog[] = [];
    deviceMeta?: DeviceMeta;
    onCourtPlayers?: { side1: OnCourtPlayer[]; side2: OnCourtPlayer[] };
    scoreSubmittedBy?: string;
}
export interface OnCourtPlayer {
    player: string;           // or Types.ObjectId | string if you keep ObjectIds
    inPoint: number;          // point number at entry
    inTime?: Date | null;     // timestamp snapshot (optional)
    outPoint?: number | null; // point number at exit (optional)
    outTime?: Date | null;   
    inSetNumber?: number | null;       // current set number   
    outSetNumber?: number | null;       // current set number   
}

export interface OnCourtPlayer {
    player: string;           // or Types.ObjectId | string if you keep ObjectIds
    inPoint: number;          // point number at entry
    inTime?: Date | null;     // timestamp snapshot (optional)
    outPoint?: number | null; // point number at exit (optional)
    outTime?: Date | null;   
    inSetNumber?: number | null;       // current set number   
    outSetNumber?: number | null;       // current set number   
  }
export interface Timeout {
    calledBy: string;
    calledByUser: string;
    sideNumber: number;
    duration: number;
    startedAt: Date | null;
    endedAt: Date| null;
    timeoutPerSet: number;
    remainingTimeoutsPerSet: number;
    timeoutPerMatch: number;
    remainingTimeoutsPerMatch: number;
    pointIndex: number;
    teamId: string;
}

export interface Server {
    sideNumber?: number;
    playerNumber?: number;
    player?: string;
    returningSide?: CourtSide;
    returnerSideNumber?: number;
    returnerPlayerNumber?: number;
    serverNumber?: number;
    returnerPlayerId?: string | null;
}

export interface  PlayerPosition {
    side1?: PlayerCourtPosition;
    side2?: PlayerCourtPosition;
}

export interface PlayerCourtPosition {
    ad?: PlayerInfo;
    deuce?: PlayerInfo;
}
export interface PlayerInfo {
    playerName: string;
    sideNumber: number;
    playerNumber: number;
    player: string | null;
}

export interface DeviceMeta {
    batteryLevel: number;
    platform: string;
    model: string;
    mode: string;
    deviceId: string;
    trackerId: string;
    timestamp: Date;
  } 
